import {isDigit} from '@sdox/utils'

export const PlaceholderChar = ({char}: {char: string}) => {
  if (!isDigit(char)) {
    return <span>{char}</span>
  }

  return <span className={'h-lh w-ch text-center'}>{char}</span>
}
